import api from './client';

function formsPath(resource, config = {}) {
  return `${config.employeeForms ? '/api/employee-forms' : '/api/forms'}/${resource}`;
}

function requestConfig(config = {}) {
  const { employeeForms, ...request } = config;
  return request;
}

export async function fetchSolarAgreements(params = {}, config = {}) {
  const { data } = await api.get(formsPath('solar-agreements', config), { params, ...requestConfig(config) });
  return Array.isArray(data) ? data : [];
}

export async function fetchSolarAgreementById(id, config = {}) {
  const { data } = await api.get(formsPath(`solar-agreements/${id}`, config), requestConfig(config));
  return data;
}

export async function createSolarAgreementFromQuotation(quotationId, config = {}, agreement) {
  const payload = agreement === undefined ? { quotationId } : { quotationId, agreement };
  const { data } = await api.post(formsPath('solar-agreements/from-quotation', config), payload, requestConfig(config));
  return data;
}

export async function previewSolarAgreementFromQuotation(quotationId, config = {}) {
  const { data } = await api.post(formsPath('solar-agreements/preview', config), { quotationId }, requestConfig(config));
  return data;
}

export async function fetchEmployeeFormQuotations(params = {}, config = {}) {
  const { data } = await api.get('/api/employee-forms/quotations', { params, ...requestConfig(config) });
  return Array.isArray(data) ? data : [];
}

export async function getEmployeeFormsCompany(config = {}) {
  const { data } = await api.get('/api/employee-forms/company', requestConfig(config));
  return data;
}

export async function updateSolarAgreement(id, payload, config = {}) {
  const { data } = await api.put(formsPath(`solar-agreements/${id}`, config), payload, requestConfig(config));
  return data;
}

export async function deleteSolarAgreement(id, config = {}) {
  await api.delete(formsPath(`solar-agreements/${id}`, config), requestConfig(config));
}

export async function fetchSolarCommissioningForms(params = {}, config = {}) {
  const { data } = await api.get(formsPath('solar-commissioning', config), { params, ...requestConfig(config) });
  return Array.isArray(data) ? data : [];
}

export async function fetchSolarCommissioningById(id, config = {}) {
  const { data } = await api.get(formsPath(`solar-commissioning/${id}`, config), requestConfig(config));
  return data;
}

export async function fetchSolarCommissioningTemplate(systemSizeKw, config = {}) {
  const { data } = await api.get(formsPath('solar-commissioning/template', config), {
    params: { systemSizeKw },
    ...requestConfig(config)
  });
  return data;
}

export async function createSolarCommissioning(payload = {}, config = {}) {
  const { data } = await api.post(formsPath('solar-commissioning', config), payload, requestConfig(config));
  return data;
}

export async function updateSolarCommissioning(id, payload, config = {}) {
  const { data } = await api.put(formsPath(`solar-commissioning/${id}`, config), payload, requestConfig(config));
  return data;
}

export async function deleteSolarCommissioning(id, config = {}) {
  await api.delete(formsPath(`solar-commissioning/${id}`, config), requestConfig(config));
}

export async function fetchSolarOcularVisits(params = {}, config = {}) {
  const { data } = await api.get(formsPath('solar-ocular-visits', config), { params, ...requestConfig(config) });
  return Array.isArray(data) ? data : [];
}

export async function fetchSolarOcularVisitById(id, config = {}) {
  const { data } = await api.get(formsPath(`solar-ocular-visits/${id}`, config), requestConfig(config));
  return data;
}

export async function fetchSolarOcularVisitTemplate(config = {}) {
  const { data } = await api.get(formsPath('solar-ocular-visits/template', config), requestConfig(config));
  return data;
}

export async function createSolarOcularVisit(payload = {}, config = {}) {
  const { data } = await api.post(formsPath('solar-ocular-visits', config), payload, requestConfig(config));
  return data;
}

export async function updateSolarOcularVisit(id, payload, config = {}) {
  const { data } = await api.put(formsPath(`solar-ocular-visits/${id}`, config), payload, requestConfig(config));
  return data;
}

export async function deleteSolarOcularVisit(id, config = {}) {
  await api.delete(formsPath(`solar-ocular-visits/${id}`, config), requestConfig(config));
}

export const SOLAR_AGREEMENT_STATUSES = ['draft', 'final', 'cancelled'];
export const SOLAR_COMMISSIONING_STATUSES = ['draft', 'completed', 'cancelled'];
export const SOLAR_OCULAR_VISIT_STATUSES = ['draft', 'completed', 'cancelled'];
